// Used when the CI workflow deploys the `development` branch — NOT for local `ng serve`
// (that's environment.local.ts). Points at the real deployed API.
export const environment = {
  production: false,
  baseUrl: 'https://trendlyapi.sequantixapps.com',
  showJsonTestPanel: false,
};
